// A hamster's cheek pouches and the sunflower seeds around it, in toy space
// with the floor at y=0. A seed carried to the mouth is pulled in and stuffed
// into the emptier cheek, which bulges by one seed's worth. A squeeze pops the
// seeds back out of the mouth one at a time, and they tumble onto the floor.
const GRAVITY=9;
export class CheekPouch{
  constructor({seeds,mouth,size=1,perCheek=3,random=Math.random}){
    this.mouth=[...mouth];this.size=size;this.perCheek=perCheek;this.random=random;
    this.home=seeds.map(p=>[...p]);
    this.seeds=seeds.map(p=>({p:[...p],v:[0,0,0],state:'floor',cheek:-1,spin:0,t:0,from:null}));
    this.cheeks=[0,0];this.bulge=[0,0];
  }
  get count(){return this.cheeks[0]+this.cheeks[1];}
  get full(){return this.count>=this.perCheek*2;}
  hold(i){const s=this.seeds[i];if(!s||!['floor','falling'].includes(s.state))return false;s.state='held';s.v=[0,0,0];return true;}
  move(i,p){const s=this.seeds[i];if(s?.state!=='held')return;s.p=[p[0],Math.max(0,p[1]),p[2]];}
  // Let go of a held seed: near the mouth it is eaten, otherwise it falls.
  drop(i){
    const s=this.seeds[i];if(s?.state!=='held')return null;
    if(!this.full&&Math.hypot(...s.p.map((n,a)=>n-this.mouth[a]))<this.size*.35){
      s.state='eating';s.t=0;s.from=[...s.p];s.cheek=this.cheeks[0]<=this.cheeks[1]?0:1;this.cheeks[s.cheek]++;return 'eat';
    }
    s.state='falling';return 'fall';
  }
  // Pop one seed out of the fuller cheek.
  eject(){
    if(!this.count)return false;
    const cheek=this.cheeks[0]>=this.cheeks[1]?0:1,s=this.seeds.find(x=>x.state==='eaten'&&x.cheek===cheek);
    if(!s)return false;
    this.cheeks[cheek]--;s.state='flying';s.cheek=-1;s.p=[...this.mouth];
    const side=(cheek?1:-1)*(.3+.4*this.random()),R=this.size;
    // Out to the side and a little forward, so it lands near the hamster.
    s.v=[side*R*1.3,R*(1.3+.4*this.random()),R*(.35+.3*this.random())];s.spin=(this.random()-.5)*12;
    return true;
  }
  step(dt){
    const events=[];
    for(const s of this.seeds){
      if(s.state==='eating'){
        s.t+=dt/.25;const k=Math.min(1,s.t);for(let a=0;a<3;a++)s.p[a]=s.from[a]+(this.mouth[a]-s.from[a])*k*k;
        if(k>=1){s.state='eaten';events.push('eat');}
      }else if(s.state==='falling'||s.state==='flying'){
        s.v[1]-=GRAVITY*this.size*dt;for(let a=0;a<3;a++)s.p[a]+=s.v[a]*dt;
        if(s.p[1]<=0){
          s.p[1]=0;
          if(Math.abs(s.v[1])>this.size*1.2){s.v[1]*=-.3;s.v[0]*=.6;s.v[2]*=.6;}
          else{s.v=[0,0,0];s.state='floor';events.push('land');}
        }
      }
    }
    // Each cheek eases toward its share of seeds, a little springy.
    for(let c=0;c<2;c++){const target=this.cheeks[c]/this.perCheek;this.bulge[c]+=(target-this.bulge[c])*Math.min(1,dt*9);if(Math.abs(target-this.bulge[c])<.001)this.bulge[c]=target;}
    return events;
  }
  reset(){this.seeds.forEach((s,i)=>{s.p=[...this.home[i]];s.v=[0,0,0];s.state='floor';s.cheek=-1;});this.cheeks=[0,0];this.bulge=[0,0];}
}
